/*
 * @Author: Hyman Choi
 * @Date: 2021-01-21 15:13:26
 * @LastEditTime: 2021-10-26 14:38:27
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Siui.Cloud.Medical.Web\src\utils\filters.js
 */
import Vue from 'vue'

/**
 * 格式化日期-时间
 */
Vue.filter('formatDateTime', value => {
    if (!value) return ""

    const date = new Date(value)
    const year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    let hours = date.getHours()
    let minutes = date.getMinutes()
    let seconds = date.getSeconds()

    if (month < 10) {
        month = '0' + month
    }
    if (day < 10) {
        day = '0' + day
    }
    if (hours < 10) {
        hours = '0' + hours
    }
    if (minutes < 10) {
        minutes = '0' + minutes
    }
    if (seconds < 10) {
        seconds = '0' + seconds
    }

    return (
        year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
    )
})

/**
 * 格式化日期
 */
Vue.filter('formatDate', value => {
    if (!value) return ""

    const date = new Date(value)
    const year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()

    if (month < 10) {
        month = '0' + month
    }
    if (day < 10) {
        day = '0' + day
    }

    return (
        year + '-' + month + '-' + day
    )
})

/**
 * 格式化秒数
 */
Vue.filter('formatSecond', value => {
    if (!value) return ""

    let h = Math.floor(value / 3600)
    let m = Math.floor((value / 60) % 60)
    if (h >= 1) {
        return h + 'h ' + m + 'min'
    } else if (m >= 1) {
        return m + 'min'
    } else {
        return '不足1min'
    }
})

/**
 * 格式化秒数为分钟
 */
Vue.filter('formatSecond2Min', value => {
    if (!value) return ""

    let m = Math.floor(value / 60)
    // if (m >= 1) {
    //     return m + 'min'
    // } else {
    //     return '不足1min'
    // }
    return m;
})


/**
 * 性别转换
 */
Vue.filter('sexTransform', value => {
    let sex
    switch (value) {
        case 0:
            sex = '男'
            break
        case 1:
            sex = '女'
            break
        case 2:
            sex = '-'
            break
    }
    return sex
})

/**
 * 用户类型转换
 */
Vue.filter('userDataTypeTransform', value => {
    let userDataType
    switch (value) {
        case 0:
            userDataType = '医用'
            break
        case 1:
            userDataType = 'DR'
            break
        case 2:
            userDataType = '医用&DR'
            break
    }
    return userDataType
})

/**
 *
 */
Vue.filter('maiLiveCarouselTypeTransform', value => {
    let type
    switch (value) {
        case 0:
            type = '平台内视频'
            break
        case 1:
            type = '平台内直播预告'
            break
        case 2:
            type = '平台内直播回顾'
            break
        case 3:
            type = '平台外视频'
            break
        case 4:
            type = '链接'
            break
    }
    return type
})

/**
 *
 */
Vue.filter('productCarouselTypeTransform', value => {
    let type
    switch (value) {
        case 0:
            type = '产品'
            break
        case 1:
            type = '产品视频'
            break
        case 2:
            type = '外链url'
            break
    }
    return type
})

/**
 *
 */
Vue.filter('activityTypeTransform', value => {
    let type
    switch (value) {
        case 0:
            type = '现场抽奖'
            break
        case 1:
            type = '抢红包'
            break
        case 2:
            type = '3D头像抽奖'
            break
        case 3:
            type = '投票活动'
            break
    }
    return type
})

/**
 * 专家等级转换
 */
Vue.filter('levelTransform', value => {
    let level
    switch (value) {
        case 0:
            level = '一级'
            break
        case 1:
            level = '二级'
            break
        case 2:
            level = '三级'
            break
    }
    return level
})

/**
 * 帖子类型转换
 */
Vue.filter('forumTypeTransform', value => {
    let forumType
    switch (value) {
        case 0:
            forumType = '普通超人圈'
            break
        case 1:
            forumType = '链接文章'
            break
        case 2:
            forumType = '视频'
            break
        case 3:
            forumType = '小视频'
            break
        case 4:
            forumType = '产品介绍'
            break
        case 5:
            forumType = '活动参加'
            break
        case 6:
            forumType = '文章'
            break
    }
    return forumType
})

/**
 * 帖子数据来源转换
 */
Vue.filter('forumSourceTransform', value => {
    let forumSource
    switch (value) {
        case 0:
            forumSource = 'SIUI分享'
            break
        case 1:
            forumSource = '用户反馈案例'
            break

    }
    return forumSource
})


/**
 * 证件类型转换
 */
Vue.filter('certificateTypeTransform', value => {
    let certificateType
    switch (value) {
        case 0:
            certificateType = '其他'
            break
        case 1:
            certificateType = '医师资格证'
            break
        case 2:
            certificateType = '护士资格证'
            break
        case 3:
            certificateType = '医学专业毕业证/学生证'
            break
        case 4:
            certificateType = '身份证'
            break
    }
    return certificateType
})

/**
 * 文件类型转换
 */
Vue.filter('formatFileType', value => {
    let type
    switch (value) {
        case 0:
            type = '图片'
            break
        case 1:
            type = '视频'
            break
        case 2:
            type = '语音'
            break
    }
    return type
})

/**
 * 设备类型转换
 */
Vue.filter('userTypeTransform', value => {
    let res
    switch (value) {
        case 0:
            res = '医用'
            break;
        case 1:
            res = '射线'
            break;
        case 2:
            res = '医用&DR'
            break;
    }
    return res
})

Vue.filter('auditStatusTransform', value => {
    let res
    switch (value) {
        case 0:
            res = '未审核'
            break;
        case 1:
            res = '已通过'
            break;
        case 2:
            res = '已驳回'
            break;
        default:
            res = res + ""
            break;
    }
    return res
})

Vue.filter('consultationRoleTransform', value => {
    let res = value
    switch (value) {
        case 0:
            res = "会诊医生"
            break;
        case 1:
            res = '会诊专家'
            break
        default:
            break;
    }
    return res
})

Vue.filter('certificateStatusTransform', value => {
    let res = value
    switch (value) {
        case 0:
            res = "未认证"
            break;
        case 1:
            res = "认证中"
            break
        case 2:
            res = "已认证"
            break
        case 3:
            res = "已驳回"
            break
        default:
            break;
    }
    return res
})

Vue.filter('userStatusTransform', value => {
    let res = value
    switch (value) {
        case 0:
            res = "停用"
            break;
        case 1:
            res = "正常"
            break
        default:
            break;
    }
    return res
})

Vue.filter('videoShareModeTransform', value => {
    let res = value
    switch (value) {
        case 0:
            res = "个人（视频列表不显示，只有自己可以看到）"
            break;
        case 1:
            res = "尊享（可以试看一段时间，后续需用券才能观看）"
            break;
        case 2:
            res = '公开，不需要用券就可以观看'
            break
    }
    return res;
})

Vue.filter('simgpleVideoShareModeTransform', value => {
    let res = value
    switch (value) {
        case 0:
            res = "个人"
            break;
        case 1:
            res = "尊享"
            break;
        case 2:
            res = '公开'
            break
    }
    return res;
})

Vue.filter('liveStateTransform', value => {
    let res = value
    switch (value) {
        case 0:
            res = "已预约"
            break;
        case 1:
            res = "直播中"
            break;
        case 2:
            res = '准备中'
            break
        case 3:
            res = '已结束'
            break
        case 4:
            res = '中场休息'
            break
    }
    return res;
})

// 0-旁观观众，1-房间观众，2-嘉宾，3-主播,4-联席主持人
Vue.filter('liveUserRoleTransform', value => {
    let res = value
    switch (value) {
        case 0:
            res = "旁路观众"
            break;
        case 1:
            res = "房间观众"
            break;
        case 2:
            res = '嘉宾'
            break
        case 3:
            res = '主播'
            break
        case 4:
            res = '联席主持人'
            break
    }
    return res;
})

// 0: 一般规则，1: 首次操作规则
Vue.filter('creditRulesTransform', value => {
    let res = value
    switch (value) {
        case 0:
            res = "一般规则"
            break;
        case 1:
            res = "首次操作"
            break;
        case 2:
            res = '管理员操作'
            break
        case 3:
            res = '后台规则'
            break
    }
    return res;
})

// 0: 否，1: 是
Vue.filter('boolValueTransform', value => {
    let res = value
    switch (value) {
        case 0:
            res = "否"
            break;
        case 1:
            res = "是"
            break;

    }
    return res;
})


// 0- 等待上传 1-正在上传 2-上传失败 3-上传完成
Vue.filter('uploadStatusTransform', value => {
    let res = value
    switch (value) {
        case 0:
            res = "等待上传"
            break;
        case 1:
            res = "正在上传"
            break;
        case 2:
            res = '上传失败'
            break
        case 3:
            res = '上传完成'
            break;

    }
    return res;
})

// 0-app内消息，1-短信，2-短信+消息
Vue.filter('notificationTypeTransform', value => {
    let res = value
    switch (value) {
        case 0:
            res = "app内消息"
            break;
        case 1:
            res = "短信"
            break;
        case 2:
            res = '短信+消息'
            break

    }
    return res;
})

// 0-用户
// 1-超人圈帖子
// 2-超人圈帖子评论
// 3-超人圈圈子
// 4-视频案例
// 5-视频案例评论
// 6-往期回顾视频
// 7-往期回顾视频评论
// 8-问答问题
// 9-问答答案
// 10-问答答案评论
// 11-直播/会议
// 12-直播间聊天信息
// 13-客服文件
// 14-圈子文件
Vue.filter('appReportObjectTypeTransform', value => {
    let res = value
    switch (value) {
        case 0:
            res = "用户"
            break;
        case 1:
            res = "超人圈话题"
            break;
        case 2:
            res = '超人圈话题评论'
            break
        case 3:
            res = '超人圈圈子'
            break
        case 4:
            res = '视频案例'
            break
        case 5:
            res = '视频案例评论'
            break
        case 6:
            res = '往期回顾视频'
            break
        case 7:
            res = '往期回顾视频评论'
            break
        case 8:
            res = '问答问题'
            break
        case 9:
            res = '问答答案'
            break
        case 10:
            res = '问答答案评论'
            break
        case 11:
            res = '直播/会议'
            break
        case 12:
            res = '直播间聊天信息'
            break
        case 13:
            res = '客服文件'
            break
        case 14:
            res = '圈子文件'
            break
    }
    return res;
})


//0-处理中 1-（举报失败）暂时无法确认违规 2-举报成功，资源已屏蔽
Vue.filter('appReportAuditStatusTransform', value => {
    let res = value
    switch (value) {
        case 0:
            res = "处理中"
            break;
        case 1:
            res = "举报失败"
            break;
        case 2:
            res = '举报成功'
            break

    }
    return res;
})

// 0-旧版普通超人圈图片
// 1-视频课程(或封面)
// 2-直播间图片
// 3-用户头像
// 4-过往病史图片
// 5-新超人圈小视频（或封面 根据ContentType判断）
// 6-超人圈评论图片或者视频
// 7-视频课程评论图片
// 8-往期回顾评论文件
// 9-超人圈帖子
// 10-超人圈评论
Vue.filter('contentSecurityResourceTypeTransform', value => {
    let res = value
    switch (value) {
        case 0:
            res = "超人圈图片"
            break;
        case 1:
            res = "视频课程"
            break;
        case 2:
            res = '直播间图片'
            break
        case 3:
            res = '用户头像'
            break
        case 4:
            res = '过往病史图片'
            break
        case 5:
            res = '超人圈小视频'
            break
        case 6:
            res = '超人圈评论'
            break
        case 7:
            res = '视频课程评论图片'
            break
        case 8:
            res = '往期回顾评论文件'
            break
        case 9:
            res = '超人圈话题'
            break
        case 10:
            res = '超人圈评论'
            break
    }
    return res;
})

//“porn”-黄色 “terrorism”-暴恐涉政 “sface”-人脸
Vue.filter('contentSecurityResultLabelTransform', value => {
    let res = value
    switch (value) {
        case 'porn':
            res = "黄色"
            break;
        case 'terrorism':
            res = "暴恐涉政"
            break;
        case 'sface':
            res = '人脸'
            break
        case 'normal':
            res = '正常'
            break
        case 'sexy':
            res = '色情'
            break

    }
    return res;
})

//建议操作 pass-正常，review-疑似违规，block -违规建议屏蔽
Vue.filter('contentSecuritySuggestionTransform', value => {
    let res = value
    switch (value) {
        case 'pass':
            res = "通过"
            break;
        case 'review':
            res = "审核"
            break;
        case 'block':
            res = '屏蔽'
            break
    }
    return res;
})

//通知发送状态 0-未发送，1-已发送成功，2-发送失败
Vue.filter('liveRegistrationSendNotificationStatusTransform', value => {
    let res = value
    switch (value) {
        case 0:
            res = "未发送"
            break;
        case 1:
            res = "发送成功"
            break;
        case 2:
            res = '发送失败'
            break
    }
    return res;
})

//终端类型 0-未知，1-android设备，2-IOS设备,3-Pc或手机浏览器设备，4-宏云设备(pie3),5-桌面直播,6-DR(pie5)
Vue.filter('terminalTypeTransform', value => {
    let res = value
    switch (value) {
       case 1:
            res = "Android设备"
            break;
        case 2:
            res = 'iOS设备'
            break
        case 3:
            res = "PC/手机浏览器"
            break
        case 4:
            res = "宏云设备(pie3)"
            break
        case 5:
            res = "桌面直播"
            break
        case 6:
            res = "DR(pie5)"
            break
        default:
            res = "未知"
            break
    }
    return res;
})

//终端类型 0-未知，1-android设备，2-IOS设备,3-Pc或手机浏览器设备，4-宏云设备(pie3),5-桌面直播,6-DR(pie5)
Vue.filter('mediaIdTransform', value => {
    let res = value
    switch (value) {
        case 'main':
            res = "摄像头"
            break;
        case 'aux':
            res = '屏幕'
            break
        case 'mix':
            res = "观众端"
            break
    }
    return res;
})